import { createFileRoute } from "@tanstack/react-router";
import { WorkspaceIntegrationsPage } from "@/features/workspaces/components/workspace-integrations/workspace-integrations.page";

export const Route = createFileRoute("/_authenticated/workspaces/$slug/integrations")({
  component: WorkspaceIntegrationsPage,
});
